<div class="full-witdh center-inner v2-h-5"
     [ngClass]="topBarClass">
  <span [ngClass]="titleClass">{{title}}</span>
  <v2-close-button class="absolute v2-right-2"
                   [mat-dialog-close]="false"
                   [svgClass]="svgClass"
                   (clicked)="dialogRef?.close()"></v2-close-button>
</div>
